    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

    let lastScroll = 0;
    const mobileSticky = document.getElementById('mobile-sticky');
    if (mobileSticky) {
        window.addEventListener('scroll', () => {
            const currentScroll = window.scrollY;
            if (currentScroll > 600 && currentScroll > lastScroll) mobileSticky.classList.add('show');
            else mobileSticky.classList.remove('show');
            lastScroll = currentScroll;
        });
    }

    const header = document.getElementById('main-header');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 10) header.classList.add('shadow-md');
            else header.classList.remove('shadow-md');
        });
    }

    document.querySelectorAll('[data-new-flooring-store-faq-button]').forEach(button => {
        button.addEventListener('click', () => {
            const item = button.closest('.faq-item');
            const body = button.nextElementSibling;
            const isOpen = body.classList.contains('open');
            document.querySelectorAll('.new-flooring-store__faq-body').forEach(faqBody => faqBody.classList.remove('open'));
            document.querySelectorAll('.new-flooring-store__faq-item').forEach(faqItem => faqItem.classList.remove('active'));
            if (!isOpen) {
                body.classList.add('open');
                item.classList.add('active');
            }
        });
    });
